import { Typography } from '@euler/app/components/typography';
import { ApdmImportState } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Pressable, View } from 'react-native';
import { useTheme } from 'styled-components';
import { importStageLabel } from '../../functions/importStageLabel';

function statusLabel(state: ApdmImportState): string {
  switch (state.kind) {
    case 'working':
      return importStageLabel(state.stage);
    case 'question':
      return '需要你指出一列';
    case 'ready':
      return '待开始导入';
    case 'publishing':
      return '正在导入';
    case 'published':
      return `已导入 · ${state.summary.visits} 条来店记录`;
    case 'failed':
      return '未完成';
    case 'deleted':
      return '已删除';
  }
}

export function ImportRow({
  state,
  selected,
  onOpen,
}: {
  state: ApdmImportState;
  selected: boolean;
  onOpen: () => void;
}) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ selected }}
      onPress={onOpen}
      style={{
        paddingVertical: rpx(10),
        borderBottomWidth: 1,
        borderColor: theme.form.input.borderColor,
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: rpx(8),
        }}
      >
        <Typography.Text
          size={rpx(14)}
          bold={selected || undefined}
          numberOfLines={1}
          color={theme.label.color}
          style={{ flex: 1 }}
        >
          {state.fileName}
        </Typography.Text>
        <Typography.Text size={rpx(12)} color={theme.label.color}>
          {state.createdAt.slice(0, 16)}
        </Typography.Text>
      </View>
      <Typography.Text size={rpx(12)} color={theme.label.color}>
        {statusLabel(state)}
      </Typography.Text>
    </Pressable>
  );
}
